function initializeATLSTInformation() {
  const root = document.getElementById('atlst-prelaunch');
  if (!root || root.dataset.infoInitialized === 'true') return;
  root.dataset.infoInitialized = 'true';
  const dialog = root.querySelector('.atlst-dialog');
  if (!dialog) return;
  const information = {
    ambassadors: {title: 'Share your ATLST moment.', copy: 'Interested in creating with ATLST? Send us a message on Instagram with your profile and a little about the moments you love to share.'},
    careers: {title: 'Grow with ATLST.', copy: 'We’re at the beginning of our journey. Follow @shopatlst for future opportunities, or introduce yourself with a message on Instagram.'},
    contact: {title: 'Let’s talk.', copy: 'Have a question about ATLST or the first collection? Send us a message on Instagram at @shopatlst.'}
  };
  root.querySelectorAll('[data-info-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const content = information[button.dataset.infoOpen];
      if (!content) return;
      dialog.querySelector('#atlst-info-title').textContent = content.title;
      dialog.querySelector('[data-info-copy]').textContent = content.copy;
      dialog.showModal();
    });
  });
  root.querySelectorAll('[data-info-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
}
initializeATLSTInformation();
document.addEventListener('shopify:section:load', initializeATLSTInformation);


// One absolute presale instant for every visitor: midnight in New York on Nov 1, 2026.
(() => {
  const zone = 'America/New_York';
  function initializePresale() {
    const root = document.getElementById('atlst-prelaunch');
    if (!root) return;
    const presale = root.querySelector('.atlst-presale');
    if (!presale || presale.dataset.clockInitialized === 'true') return;
    presale.dataset.clockInitialized = 'true';
    const targetMs = Date.parse(presale.dataset.presaleAt);
    const counter = presale.querySelector('.atlst-counter');
    const status = presale.querySelector('.atlst-presale-status');
    const timing = presale.querySelector('[data-presale-time]');
    const heading = presale.querySelector('[data-presale-heading]');
    const dateLabels = root.querySelectorAll('[data-presale-date]');
    const dateStamps = root.querySelectorAll('[data-presale-stamp]');
    if (!Number.isFinite(targetMs)) {
      counter.hidden = true;
      timing.hidden = true;
      heading.textContent = 'Presale details coming soon.';
      dateLabels.forEach((label) => { label.hidden = true; });
      dateStamps.forEach((stamp) => {
        stamp.textContent = 'Coming soon';
        stamp.classList.add('atlst-date-unconfirmed');
        stamp.removeAttribute('datetime');
      });
      return;
    }
    const date = new Date(targetMs);
    const prettyDate = new Intl.DateTimeFormat('en-US', { timeZone: zone, month: 'long', day: 'numeric', year: 'numeric' }).format(date);
    const shortDate = new Intl.DateTimeFormat('en-US', { timeZone: zone, month: '2-digit', day: '2-digit', year: '2-digit' }).format(date).replaceAll('/', '.');
    const time = new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: 'numeric', minute: '2-digit' }).format(date);
    dateLabels.forEach((label) => { label.textContent = prettyDate; label.setAttribute('datetime', date.toISOString()); });
    dateStamps.forEach((stamp) => { stamp.textContent = shortDate; stamp.setAttribute('datetime', date.toISOString()); });
    timing.textContent = time + ' · Eastern Time';
    const fields = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map((unit) => [unit, presale.querySelector('[data-count-unit="' + unit + '"]')]));
    let interval = null;
    function tick() {
      if (!root.isConnected) { if (interval !== null) clearInterval(interval); return; }
      const seconds = Math.max(0, Math.ceil((targetMs - Date.now()) / 1000));
      if (seconds === 0) {
        counter.hidden = true;
        timing.hidden = true;
        heading.textContent = 'The countdown is complete.';
        dateLabels.forEach((label) => { label.hidden = true; });
        status.textContent = 'Follow @shopatlst for the latest presale news.';
        status.hidden = false;
        if (interval !== null) clearInterval(interval);
        return false;
      }
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
      Object.entries(values).forEach(([unit, value]) => { fields[unit].textContent = String(value).padStart(2, '0'); });
      counter.hidden = false;
      status.hidden = true;
      return true;
    }
    if (tick()) interval = setInterval(tick, 1000);
  }
  initializePresale();
  if (!window.atlstPresaleEvents) {
    document.addEventListener('shopify:section:load', initializePresale);
    window.atlstPresaleEvents = true;
  }
})();


// Store access is available at /password#atlst-store-access without changing
// the approved public footer. Shopify validates the password server-side.
function initializeATLSTNativeForms() {
  const root = document.getElementById('atlst-prelaunch');
  if (!root) return;
  const password = root.querySelector('[data-atlst-password-dialog]');
  if (password && password.dataset.initialized !== 'true') {
    password.dataset.initialized = 'true';
    const showPassword = () => {
      if (window.location.hash === '#atlst-store-access' || password.querySelector('[data-atlst-password-error]')) {
        if (!password.open) password.showModal();
        password.querySelector('input[type="password"]').focus();
      }
    };
    password.querySelector('[data-atlst-password-close]').addEventListener('click', () => password.close());
    password.addEventListener('click', (event) => {
      if (event.target !== password) return;
      const rect = password.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) password.close();
    });
    window.addEventListener('hashchange', showPassword);
    showPassword();
  }
  const activeForm = window.location.hash === '#ATLSTNewsletter' ? root.querySelector('#ATLSTNewsletter') : root.querySelector('#ATLSTLaunch');
  const status = activeForm && activeForm.querySelector('[data-atlst-form-status]');
  if (status) status.focus();
}
initializeATLSTNativeForms();
document.addEventListener('shopify:section:load', initializeATLSTNativeForms);
